import { useApi } from "@/lib/api";
import { Field, Sel } from "@/components/common";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export function useCatalog() {
  return useApi("/providers/catalog").data;
}

export default function ModelPicker({ value, onChange, catalog, testid, allowNone = false, task }) {
  const v = value || {};
  const prov = catalog?.providers.find((p) => p.id === v.provider_id);
  const models = (prov?.models || []).filter((m) => !task || (m.tasks || []).includes(task));
  const model = models.find((m) => m.id === v.model);
  const set = (patch) => onChange({ ...v, ...patch });
  return (
    <div className="space-y-3" data-testid={testid}>
      <div className="grid sm:grid-cols-2 gap-3">
        <Field label="Fournisseur" helpTopic="fournisseurs">
          <Sel testid={`${testid}-provider`} value={v.provider_id} onChange={(id) => set({ provider_id: id, model: "", params: {} })}
            options={(catalog?.providers || []).map((p) => ({ value: p.id, label: `${p.name}${p.configured ? "" : " (non configuré)"}` }))} />
        </Field>
        <Field label="Modèle">
          <Sel testid={`${testid}-model`} value={v.model} onChange={(m) => set({ model: m, params: {} })} options={models.map((m) => ({ value: m.id, label: m.label }))} />
        </Field>
      </div>
      {model && (
        <div className="grid sm:grid-cols-3 gap-3">
          {model.params.map((p) => (
            <Field key={p.name} label={p.label} hint={p.type === "enum" ? "" : `${p.min} – ${p.max}`}>
              {p.type === "enum" ? (
                <Sel value={v.params?.[p.name] ?? p.default} onChange={(x) => set({ params: { ...v.params, [p.name]: x } })} options={p.options.map((o) => ({ value: o, label: o }))} />
              ) : (
                <Input type="number" step={p.step} min={p.min} max={p.max} data-testid={`${testid}-param-${p.name}`}
                  value={v.params?.[p.name] ?? p.default} onChange={(e) => set({ params: { ...v.params, [p.name]: p.type === "int" ? parseInt(e.target.value) : parseFloat(e.target.value) } })} />
              )}
            </Field>
          ))}
        </div>
      )}
      {model && <p className="text-[11px] text-muted-foreground">Seuls les paramètres pris en charge par ce modèle sont affichés. {model.price ? `Tarif standard estimé : ${model.price[0]} € / ${model.price[1]} € par million de tokens (entrée / sortie), selon le catalogue et la conversion configurés.` : "Tarif non renseigné."} Voir « Coûts & simulation ».</p>}
      {allowNone && v.model && <Button size="sm" variant="ghost" onClick={() => onChange(null)} data-testid={`${testid}-clear`}>Retirer ce modèle</Button>}
    </div>
  );
}

